import styled from '@emotion/styled'

import { breakpoints, spacing, Text, typography } from 'main/ui'

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${spacing.majorScale(8)}px;
  @media (max-width: ${breakpoints.lg}px) {
    padding: ${spacing.majorScale(6)}px ${spacing.majorScale(2)}px;
  }
`

export const SectionTitle = styled(Text)`
  font-size: ${typography.fontSize.title.large};
  font-weight: ${typography.fontWeight.bold};
  margin-bottom: ${spacing.majorScale(2)}px;
`

export const SectionDescriptionText = styled(Text)`
  text-align: center;
  margin-bottom: ${spacing.majorScale(5)}px;
  width: 45%;
  @media (max-width: ${breakpoints.lg}px) {
    width: 100%;
    text-align: start;
  }
`

export const FeaturesContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 80%;

  @media (max-width: ${breakpoints.lg}px) {
    flex-direction: column;
    width: 100%;
  }
`

export const FeatureItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }

  @media (max-width: ${breakpoints.lg}px) {
    flex-direction: column;
    margin-bottom: ${spacing.majorScale(4)}px;
  }
`

export const FeatureTitle = styled(Text)`
  font-size: ${typography.fontSize.title.normal};
`

export const FeatureDescriptionText = styled(Text)`
  @media (max-width: ${breakpoints.lg}px) {
    padding: 0 ${spacing.majorScale(1)}px;
  }
`

export const IconContainer = styled.div`
  display: flex;
  align-self: center;
`

export const Icon = styled.img`
  height: ${spacing.majorScale(3)}px;
  width: ${spacing.majorScale(3)}px;
`
